module.exports = __webpack_public_path__ + "static/media/bus_seat_selection.c5bb797b.svg";